var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.27039C11.0649 4.27039 3.41711 11.9194 3.41711 21.3533C3.41711 30.7871 11.0662 38.4362 20.5 38.4362C29.9351 38.4362 37.5829 30.7871 37.5829 21.3533C37.5727 11.9233 29.93 4.28064 20.5 4.27039H20.4987H20.5ZM28.5924 17.384L19.197 27.634C18.8831 27.9748 18.4359 28.1888 17.9375 28.1888C17.4391 28.1888 16.992 27.9761 16.6793 27.6353L16.6781 27.634L12.4076 22.9754C12.1296 22.673 11.9592 22.2668 11.9592 21.8209C11.9592 20.8779 12.7241 20.1118 13.6671 20.1118C14.1655 20.1118 14.6127 20.3244 14.9253 20.6653L14.9266 20.6665L17.9375 23.9517L26.0735 15.0752C26.3874 14.7344 26.8345 14.5217 27.3329 14.5217C28.2759 14.5217 29.0421 15.2866 29.0421 16.2309C29.0421 16.6767 28.8717 17.0829 28.5924 17.3865L28.5937 17.3853L28.5924 17.384Z",
    fill: "#0BC012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a776adba6eba5e2008ff61f345af91fd.svg";
export { ForwardRef as ReactComponent };